import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { ScheduleALesson } from "../../../Constant";
import DatePicker from "react-datepicker";
import { useState } from "react";

const ScheduleLesson = () => {
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const handleChange = (date: Date | null) => setStartDate(date);

  return (
    <Col xl="4" m="12" lg="5" className="box-col-4e">
      <Card>
        <CommonCardHeader title={ScheduleALesson} className="card-no-border pb-0" />
        <CardBody className="d-flex">
          <div className="schedule-lesson">
            <div className="default-datepicker datepicker-here">
              <DatePicker onChange={handleChange} selected={startDate} inline />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ScheduleLesson;
